import { inject } from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import { Observable, } from "rxjs";
import {map} from "rxjs/operators";
import {PublicLeagueDataStore} from "@store";
import {extractIdFromSlug} from "../utility/slug-helper";


export const PublicLeagueInitResolver: ResolveFn<boolean> =
    (route: ActivatedRouteSnapshot, _: RouterStateSnapshot,
     store: PublicLeagueDataStore = inject(PublicLeagueDataStore)): Observable<boolean> => {
        const leagueId = route.queryParams['leagueId']
            ? +route.queryParams['leagueId']
            : extractIdFromSlug(route.params['slug'] ?? '') ?? 0;
        return store.preloadAll(leagueId).pipe(
            map(() => true)
        );
    };